import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=6af8f3e4"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports